import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Button from '../ui/Button'

// Import SVG icons as components or URLs
import logoWhite from '../../assets/images/logo-white.svg'
import menuIcon from '../../assets/images/menu.svg'
import closeIcon from '../../assets/images/close.svg'

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const navigationItems = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT US', path: '/about' },
    { name: 'SERVICES', path: '/services' },
    { name: 'NEWS', path: '/news' },
  ]

  const handleDeliveryPartnersClick = () => {
    setIsMobileMenuOpen(false)
    navigate('/deliver')
  }

  // Handler for "Request a Custom Quote"
  const handleRequestQuoteClick = () => {
    setIsMobileMenuOpen(false)
    navigate('/request-quote')
  }

  return (
    <>
      {/* Main Header */}
      <header className="bg-black/70 text-white fixed top-0 left-0 right-0 z-50" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
        <div className="container mx-auto px-4 sm:px-8 py-3 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img 
                  src={logoWhite} 
                  alt="Speedyssey" 
                  className="h-8 w-auto"
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6">
              {/* <Button
                title="Sign in"
                onClick={() => console.log('Sign in clicked')}
                variant="ghost"
                size="sm"
              /> */}
              <Button
                title="Request a Custom Quote"
                onClick={handleRequestQuoteClick}
                variant="outline"
                size="sm"
              />
              {/* Desktop Menu Button */}
              <button
                onClick={toggleMobileMenu}
                className="text-white  rounded-full  transition-colors"
                aria-label="Toggle menu"
              >
                <img 
                  src={isMobileMenuOpen ? closeIcon : menuIcon} 
                  alt={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                  className="w-10 h-10"
                />
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={toggleMobileMenu}
                className="text-white p-2"
                aria-label="Toggle menu"
              >
                <img 
                  src={isMobileMenuOpen ? closeIcon : menuIcon} 
                  alt={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                  className="w-6 h-6"
                />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Dropdown Menu */}
      <div className={`fixed left-0 right-0  top-[88px] bg-black/70 z-40 transition-all duration-500 ease-in-out overflow-hidden ${
        isMobileMenuOpen ? ' opacity-100 py-10' : 'h-0 opacity-0'
      }`} style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
        <div className="flex flex-col items-end justify-center h-full space-y-8 text-white px-8 pr-16">
          {/* Navigation Items */}
          <nav className="flex flex-col items-end space-y-6">
            {navigationItems.map((item) => { 
              const isActive = item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
              return (
              <Link
                key={item.name}
                to={item.path}
                className={`special-header flex items-center text-4xl md:text-5xl font-bold tracking-wider hover:text-gray-300 transition-colors duration-300 ${
                  isMobileMenuOpen ? 'animate-slide-in' : ''
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
                {isActive && (
                  <span className="w-3 h-3 bg-[#F55109] rounded-full ml-4"></span>
                )}
              </Link>
              );
            })}
          </nav>

          {/* Action Buttons in Mobile Menu */}
          <div className="mt-8 flex flex-col items-end space-y-4">
            <button 
              className="px-8 py-3.5 bg-[#F55109] text-white rounded-full text-sm font-semibold hover:bg-[#d44304] transition-colors duration-300 shadow-md"
              onClick={handleRequestQuoteClick}
            >
              Request a Custom Quote
            </button>
            <button 
              className="px-8 py-3.5 bg-white text-black rounded-full text-sm font-medium hover:bg-gray-200 transition-colors duration-300"
              onClick={handleDeliveryPartnersClick}
            >
              For Delivery Partners
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
